import React, { useState, SyntheticEvent } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

const ServiceFaq: React.FC = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (_event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <section className="wpo-faq-section section-padding">
      <div className="container-fluid">
        <div className="title">
          <h4 className="poort-text poort-in-right">Project Solution</h4>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                >
                  <AccordionSummary
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography className="accordion-header">
                      Market research on our global panel with support from our
                      experts.
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="accordion-body">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Eum exercitationem pariatur iure nemo esse repellendus est
                      quo recusandae. Delectus, maxime.
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange("panel2")}
                >
                  <AccordionSummary
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography className="accordion-header">
                      Planning can help alleviate workplace stress and increase
                      productivity.
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="accordion-body">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Eum exercitationem pariatur iure nemo esse repellendus est
                      quo recusandae. Delectus, maxime.
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange("panel3")}
                >
                  <AccordionSummary
                    aria-controls="panel3-content"
                    id="panel3-header"
                  >
                    <Typography className="accordion-header">
                      Those who experiment the most are able to innovate the
                      best.
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="accordion-body">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Eum exercitationem pariatur iure nemo esse repellendus est
                      quo recusandae. Delectus, maxime.
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleChange("panel4")}
                >
                  <AccordionSummary
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    <Typography className="accordion-header">
                      Understand your problem — you must understand the issue.
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="accordion-body">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Eum exercitationem pariatur iure nemo esse repellendus est
                      quo recusandae. Delectus, maxime.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceFaq;
